const REQUEST_GAME = '@@shifts/REQUEST_GAME';
const GAME_RESPONSE = '@@shifts/GAME_RESPONSE';
const REQUEST_GAME_SHIFTS = '@@shifts/REQUEST_GAME_SHIFTS';
const GAME_SHIFTS_RESPONSE = '@@shifts/GAME_SHIFTS_RESPONSE';
const REQUEST_TEAM_DATA = '@@shifts/REQUEST_TEAM_DATA';
const TEAM_DATA_RESPONSE = '@@shifts/TEAM_DATA_RESPONSE';

export default {
    REQUEST_GAME,
    GAME_RESPONSE,
    REQUEST_GAME_SHIFTS,
    GAME_SHIFTS_RESPONSE,
    REQUEST_TEAM_DATA,
    TEAM_DATA_RESPONSE,
};
